import { useTranslation } from 'react-i18next';

import AppStoreLogo from '../../../assets/images/apple.png';
import PlayStoreLogo from '../../../assets/images/google_play.png';
import { brandLinks } from '../../../config/branding';
import { getLocalStorageItem } from '../../../shared-functions/LocalStorage';

/**
 * Store Link component rendering mobile app download links
 * @returns The rendered store download links element.
 */
function StoreLink() {
  const { t } = useTranslation('charger');
  const appVersion = getLocalStorageItem('appVersion') || '';
  const appLinks = [
    {
      key: 'play-store',
      image: PlayStoreLogo,
      url: brandLinks.playStore,
    },
    {
      key: 'app-store',
      image: AppStoreLogo,
      url: brandLinks.appStore,
    },
  ];

  return (
    <div className="store-link-wrap">
      <div className="download-buttons-container">
        <div className="horizontal-bg-line" />
        <div className="download-buttons">
          {appLinks.map((appLink) => (
            <div className="download-button">
              <a
                href={appLink.url}
                target="_blank"
                rel="noreferrer"
                aria-labelledby="download-invoice">
                <img src={appLink.image} alt="" />
              </a>
            </div>
          ))}
        </div>
        <div className="horizontal-bg-line" />
      </div>
      <div className="download-text">
        <p>{t('downloadAppText')}</p>
        <p>{appVersion}</p>
      </div>
    </div>
  );
}

export default StoreLink;
